import { StoryCard } from './StoryCard'
import { withStoryCard } from './withStoryCard'

const ConnectedStoryCard = withStoryCard(StoryCard)

export { ConnectedStoryCard as StoryCard }
